import React, { useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import * as actions from '../../../../store/actions/profileActions';

import heartbeat from '../../../../assets/img/home/heartbeat.svg';
import ethnicity from '../../../../assets/img/home/Ethnicity.svg';
import religion from '../../../../assets/img/home/Religion.svg';
import politics from '../../../../assets/img/home/Politics.svg';
import smoking from '../../../../assets/img/home/Smoking.svg';
import drinking from '../../../../assets/img/home/Drinking.svg';
import height from '../../../../assets/img/home/Height.svg';

import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

const Virtues = ({ virtues }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [open, setOpen] = useState(false);
    const profileState = useSelector(state => state.profile);
    const dispatch = useDispatch();

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setOpen(false);
      };
    
    const handleChange = (e) => {
        if (profileState.userProfile.virtue[e.target.name] !== e.target.value) {
            setIsEditing(true);
            dispatch(actions.collectProfileData({...profileState.profile, virtue: {...profileState.profile.virtue, [e.target.name]: e.target.value}}));
        }
        else {
            setIsEditing(false);
        }
    }

    const handleReset = () => {
        dispatch(actions.collectProfileData({...profileState.profile, virtue: profileState.userProfile.virtue}));
        setIsEditing(false);
    }

    const handleSave = () => {
        dispatch(actions.updateProfile(profileState.profile))
            .then(() => {
                setOpen(true);
                setIsEditing(false);
            });
    }
    return (
        <div className="content">      
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success">
                    Profile Successfully Updated!
                </Alert>
            </Snackbar>      
            <div className="info-block">
                            
                <div className="info-row">

                    <div className="key" style={{marginRight: '10px'}}>
                        <img src={ethnicity} alt="height" />
                        <p className="info-title">Ethnicity</p>
                    </div>
                    <div className="value">
                        <select className="uni-select" name="ethnicity" id="Ethnicity" defaultValue={virtues.ethnicity} value={virtues.ethnicity} onChange={handleChange}>
                            <option value="African">African</option>
                            <option value="Caucasian">Caucasian</option>
                            <option value="Coloured">Coloured</option>
                            <option value="Asian">Asian</option>
                            <option value="Indian">Indian</option>
                            <option value="Other">Other</option>
                            <option value="Prefer Not to Say">Prefer Not to Say</option>
                        </select>   
                    </div>
                    
                </div>

                <div className="info-row">

                    <div className="key" style={{marginRight:'10px'}}>
                        <img src={religion} alt="height" />
                        <p className="info-title">Religion</p>
                    </div>
                    <div className="value">
                        <select className="uni-select" name="religion" id="Religion" value={virtues.religion} onChange={handleChange}>
                            <option value="Buddhsit">Buddhsit</option>
                            <option value="Jewish">Jewish</option>
                            <option value="Hindu">Hindu</option>
                            <option value="Agnostic">Agnostic</option>
                            <option value="Catholic">Catholic</option>
                            <option value="Christian">Christian</option>
                            <option value="Muslim">Muslim</option>
                            <option value="Atheist">Atheist</option>
                            <option value="Spiritual">Spiritual</option>
                            <option value="Other">Other</option>
                            <option value="Prefer Not to Say">Prefer Not to Say</option>
                        </select>
                    </div>
                    
                </div>

                <div className="info-row">

                    <div className="key">
                        <img style={{marginRight:'10px'}} src={smoking} alt="height" />
                        <p className="info-title" style={{paddingTop: '15px'}}>Smoking</p>
                    </div>
                    <div className="value">
                        <select className="uni-select" name="smoking" id="Smoking" value={virtues.smoking} onChange={handleChange}>
                            <option value="Socially">Socially</option>
                            <option value="Regularly">Regularly</option>
                            <option value="Never">Never</option>
                            <option value="Prefer Not to Say">Prefer Not to Say</option>
                        </select> 
                    </div>
                    
                </div>

                <div className="info-row">

                    <div className="key">
                        <img style={{marginRight:'10px'}} src={drinking} alt="height" />
                        <p className="info-title">Drinking</p>
                    </div>
                    <div className="value">
                        <select className="uni-select" name="drinking" id="Drinking" value={virtues.drinking} onChange={handleChange}>
                            <option value="Socially">Socially</option>
                            <option value="Regularly">Regularly</option>
                            <option value="Never">Never</option>
                            <option value="Prefer Not to Say">Prefer Not to Say</option>
                        </select>
                    </div>
                    
                </div>

                <div className="info-row">

                    <div className="key">
                        <img style={{marginRight:'10px'}} src={height} alt="height" />
                        <p className="info-title">Height</p>
                    </div>
                    <div className="value">
                        <p className="info-data">{virtues.height}cm</p>
                    </div>
                    
                </div>

                <div className="info-row">

                    <div className="key">
                        <img style={{marginRight:'10px'}} src={politics} alt="height" />
                        <p className="info-title">Politics</p>
                    </div>
                    <div className="value">
                        <select className="uni-select" name="politicalView" id="Politics" value={virtues.politicalView} onChange={handleChange}>
                            <option value="Liberal">Liberal</option>
                            <option value="Apolitical">Apolitical</option>
                            <option value="Moderate">Moderate</option>
                            <option value="Conservative">Conservative</option>
                            <option value="Other">Other</option>
                            <option value="Prefer Not to Say">Prefer Not to Say</option>
                        </select> 
                    </div>
                </div>
                
                {isEditing ? 
                    <div>
                        <button className="uni-btn" onClick={handleSave}>Save</button>
                        <button className="uni-btn" onClick={handleReset}>Reset</button>
                    </div> 
                : null}
            </div>
        </div>
    )
}

export default Virtues;
